import _ from 'lodash';
import moment from 'moment';

function Ctrl($scope, utilsService, $sce) {
  $scope.richJson = function() {
    if (!$scope.event || !$scope.event.venue) return '';

    const {
      event
    } = $scope;
    const venue = event.venue;
    venue.location = venue.location || {};
    venue.location.address = venue.location.address || {};

    const json = {
      '@context': 'http://schema.org',
      '@type': 'Event',
      name: event.name,
      startDate: moment.utc(event.dateStart).format('YYYY-MM-DDTHH:mm:ss'),
      endDate: moment.utc(event.dateEnd).format('YYYY-MM-DDTHH:mm:ss'),
      url: utilsService.createUrl(`/e/${event.seoPathname}`),
      description: `Buy tickets and tables to ${event.name} at ${venue.name}`,
      image: _.get(event, 'primaryImage.filename'),
      location: {
        '@type': 'Place',
        sameAs: utilsService.createUrl(`/v/${venue.seoPathname}` || venue.id),
        name: venue.name,
        address: `${venue.location.address.address}, ${venue.location.address.city}, ${venue.location.address.state} ${venue.location.address.zip}`
      },
      // performer: {
      //   '@person': event.name
      // },
      offers: [{
        '@type': 'Offer',
        availability: 'https://schema.org/InStock',
        price: 0,
        priceCurrency: venue.currencyCode,
        validFrom: moment.utc(event.dateStart).format('YYYY-MM-DDTHH:mm:ss'),
        url: utilsService.createUrl(`/e/${event.seoPathname}`)
      }]
    };

    if (event.performers && event.performers.length) {
      json.performer = event.performers.map(performer => {
        return {
          '@type': performer.group ? 'MusicGroup' : 'Person',
          name: performer.name,
          sameAs: performer.website
        };
      });
    }

    return $sce.trustAsHtml(JSON.stringify(json, null, 2));
  };
}

Ctrl.$inject = [
  '$scope',
  'utilsService',
  '$sce'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/richEventCard/controller.js